import { campaignPhoneNumbers } from "~/static/data/campaignPhoneNumbers";

export const nz = {
	areaServed: "NZ",
	contactType: "customer service",
	number: "09 974 1598",
	telephone: "+6499741598",
	agent: {
		number: "09 922 6756",
		telephone: "+6499226756",
	},
	corporate: {
		number: "09 917 9917",
		telephone: "+6499179917",
	}
};

export const au = {
	areaServed: "AU",
	contactType: "customer service",
	number: "+61 2 6189 9181",
	telephone: "+61261899181",
};

export const us = {
	areaServed: "US",
	contactType: "customer service",
	number: "+1 203 666 8615",
	telephone: "+12036668615",
};

export const uk = {
	areaServed: "UK",
	contactType: "customer service",
	number: "+44 204 586 8842",
	telephone: "+442045868842",
};

export const worldwide = {
	areaServed: "Worldwide",
	contactType: "customer service",
	number: "+64 9 974 1598",
	telephone: "+6499741598",
	agent: {
		number: "+64 9 922 6756",
		telephone: "+6499226756",
	},
	corporate: {
		number: "+64 9 917 9917",
		telephone: "+6499179917",
	}
};

export default {
	nz,
	au,
	us,
	uk,
	worldwide,
};

export const contactPointService = {
	getActiveCampaignPhoneNumbers(context) {
		if (typeof window !== 'undefined') {
			const urlParams = new URLSearchParams(window.location.search);
			let campaignName = urlParams.get('Campaign');

			if (campaignName) {
				context.$store.commit('campaign/updateCampaign', { name: campaignName });
			} else {
				campaignName = context.$store.state.campaign.campaign.name;
			}

			if (campaignName && !this.isEmptyObject(campaignPhoneNumbers[campaignName])) {
				const locations = { nz, au, us, uk, worldwide };

				Object.keys(locations).forEach(locationKey => {
					const campaignData = campaignPhoneNumbers[campaignName][locationKey];

					if (campaignData) {
						this.updateContactPoint(locations[locationKey], campaignData.telephone, campaignData.number);
					}
				});
			}
		}
	},
	updateContactPoint(contactPoint, telephone, number) {
		if (telephone) {
			contactPoint.telephone = telephone;
		}
		if (number) {
			contactPoint.number = number;
		}
	},
	isEmptyObject(obj) {
		return !obj || Object.keys(obj).length === 0;
	}
};
